export enum VacanciesRoute {
  SEARCH_VACANCIES = 'search-vacancies',
  TOP_VACANCY = 'top-vacancy',
  VACANCY_DETAILS = 'vacancy-details',
  VACANCY_DETAILS_404 = 'vacancy-details/404',
  VACANCY_APPLICATION_FORM = 'vacancy-application-form',
  SPONTANEOUS_APPLICATION_FORM = 'spontaneous-application-form',
  APPLICATION_CONFIRMATION = 'application-confirmation',
}
